import { HttpClient } from '@angular/common/http';
import { forwardRef, Inject, resolveForwardRef } from '@angular/core';
import { ConfigLoader } from '@ngx-config/core';

export class MngConfigHttpLoader implements ConfigLoader {
  constructor(
    @Inject(forwardRef(() => HttpClient)) private readonly http: HttpClient,
    private readonly endpoint: string = '/config.json',
    private readonly fallbackSettings?: any
  ) {}

  loadSettings(): any {
    return new Promise((resolve, reject) => {
      const http = resolveForwardRef(this.http);

      http.get(this.endpoint).subscribe(
        (res: any) => resolve(res),
        () => (this.fallbackSettings ? resolve(this.fallbackSettings) : reject('Endpoint unreachable!'))
      );
    });
  }
}
